import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class UpdateItemArchivedStatusDto {
  @Expose()
  @Transform(({ value }) => (value ? parseAppDate(value) : null))
  archivedAt?: string;
}
